import React from "react";
import Typography from '@mui/material/Typography'
import Link from 'next/link'
import darkTheme from '../src/theme';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const breakImageContainer = {  
  background: `url('../images/ClubrHeader.png')`,
  objectFit: 'contain',
  backgroundSize: 'contain',
  backgroundRepeat : 'no-repeat',
  textTransform: 'capitalize',
  transition: "transform 0.35s ease-in-out",
  boxShadow: darkTheme.shadows[0],   
  paddingTop: darkTheme.spacing(12),
  paddingBottom: darkTheme.spacing(20),
  paddingLeft: darkTheme.spacing(15),
  paddingRight: darkTheme.spacing(15),
  maxWidth: '100%',
  '& h4': {
    fontSize: 50,
    color: darkTheme.palette.background.default,
    fontWeight:700
  },
  '& h5': {
    fontSize: 18,
    color: darkTheme.palette.grey[200],
    lineHeight: 1.7,
    fontWeight: 700,
    maxWidth: '70%'
  },               
  [darkTheme.breakpoints.down("lg")]: {  
    paddingTop: darkTheme.spacing(5),
    paddingBottom: darkTheme.spacing(5),
    paddingLeft: darkTheme.spacing(15),
    paddingRight: darkTheme.spacing(15),
  },
  [darkTheme.breakpoints.down("md")]: {  
    display: 'none'
  }
};

function BreakImageContainer(props) {
  return (    
      <Typography component="div"
        style={{ height: "100% !important" }}
        sx={breakImageContainer}
      >      
        <Typography variant="h4" sx={{width:'50%'}}>
          {props.title}
        </Typography>
        <Typography variant="h5" sx={{width:'50%'}}>
          {props.text}
        </Typography>
        <Typography component="div" sx={{mt:3, width:'60%'}}>
        <Link href={props.buttonURL} target="_blank" rel="noreferrer" >
            <a className="rippleBtnAlt" style={{padding:'10px 0px', display:'flex', alignItems:'center', color: darkTheme.palette.background.default}}>
            {props.buttonText}              
              <span><ArrowForwardIcon sx={{ fontSize: '14px', color: darkTheme.palette.primary.main, zIndex:3 }} /></span>              
            </a>
          </Link>
        </Typography>                         
      </Typography>         
  );
}

export default BreakImageContainer;
